/***************************************************************
5/22/2017
Alexander Self
Timesheet Summary View
- Displays daily timesheet summaries
***************************************************************/
import React from 'react';

const TimesheetSummaryView = ({ timesheets }) => {
  function mapGangTimesheets(timesheets) {
    return timesheets.map((ts) => {
      if (ts.harvest.length > 0) {
        return (
          <tr key={ts.eid}>
            <td>{ts.firstName} {ts.lastName}</td>
            <td>{ts.eid}</td>
            <td>{ts.grade}</td>
            <td>{ts.shift}</td>
            <td>{ts.regHours}</td>
            <td>{ts.otHours}</td>
            <td>{ts.doubleTime}</td>
            <td>{ts.summaryOfHours}</td>
            <td>{ts.gang}</td>
            <td>{ts.location}</td>
            <td>{ts.harvest.length > 0 ? ts.harvest.reduce((acc, cur) => { return acc + cur.trees},0) : ''}</td>
            <td>{ts.harvest.length > 0 ? ts.harvest.reduce((acc, cur) => { return acc + cur.bags},0) : ''}</td>
            <td>${ts.harvest.length > 0 ? ts.harvest.reduce((acc, cur) => { return acc + cur.incentive},0.00) : ''}</td>
          </tr>
        )
      }
      return <tr key={Math.random()}></tr>;
    })
  }
  return (
    <div>
      {/* Gang Table */}
      { timesheets.length > 0 ?
        <div>
          <h5>Team Submitted Timesheets</h5><hr />
          <div className="row">
            <table className="bordered responsive-table highlight centered">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>EID</th>
                  <th>Grade</th>
                  <th>Shift</th>
                  <th>Reg. Hrs</th>
                  <th>OT Hrs</th>
                  <th>DT Hrs</th>
                  <th>Total Hrs</th>
                  <th>Team</th>
                  <th>Location</th>
                  <th>Trees</th>
                  <th>Bags</th>
                  <th>Bonus</th>
                </tr>
              </thead>
              <tbody>
                { mapGangTimesheets(timesheets) }
              </tbody>
            </table>
          </div>
        </div>
      : '' }
    </div>
  );
};

export default TimesheetSummaryView;




























/* END */



// WEBPACK FOOTER //
// ./src/components/timesheets/view/timesheet_view_summary.js